import { subscriptionPlans } from "common/constants";

const subscriptionPlansSortOrder = [
    subscriptionPlans.nakiRadioPremium,
    subscriptionPlans.nakiOne,
    subscriptionPlans.nakiTales,
    subscriptionPlans.nakiNigun,
    subscriptionPlans.nakiRadioFree,
];

export default subscriptionPlansSortOrder;
